// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Minoxidil / Finasteride   (Men & Women) 09.17.26" (b6b8d045-12de-45fb-90c5-dbefb579964d). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiMinoxidilFinasterideMenWomenAnswerField } from './questions';

export const mdiMinoxidilFinasterideMenWomen: FormType<mdiMinoxidilFinasterideMenWomenAnswerField> =
  {
    name: 'Minoxidil / Finasteride (Men & Women)',
    validityLength: 25,
    questions: [
      {
        key: 'mdiMinoxidilFinasterideMenWomen_sex',
        next: {
          switch: [
            {
              condition: { 'mdiMinoxidilFinasterideMenWomen_sex.female': true },
              key: 'mdiMinoxidilFinasterideMenWomen_pregnancy'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_pregnancy.yes': true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_wereSorryDueEitherBeing'
            },
            {
              condition: { 'mdiMinoxidilFinasterideMenWomen_sex.male': true },
              key: 'mdiMinoxidilFinasterideMenWomen_tryingConceivePlanConceivingNear'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_tryingConceivePlanConceivingNear.yes':
                  true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_wereSorryBasedPreviousResponse'
            }
          ],
          els: 'mdiMinoxidilFinasterideMenWomen_primaryConcern'
        }
      },
      {
        key: 'mdiMinoxidilFinasterideMenWomen_pregnancy',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_pregnancy.yes': true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_wereSorryDueEitherBeing'
            },
            {
              condition: { 'mdiMinoxidilFinasterideMenWomen_sex.male': true },
              key: 'mdiMinoxidilFinasterideMenWomen_tryingConceivePlanConceivingNear'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_tryingConceivePlanConceivingNear.yes':
                  true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_wereSorryBasedPreviousResponse'
            },
            {
              condition: { 'mdiMinoxidilFinasterideMenWomen_sex.female': true },
              key: 'mdiMinoxidilFinasterideMenWomen_requiredAcknowledgmentUnderstandFormulationContains'
            }
          ],
          els: 'mdiMinoxidilFinasterideMenWomen_primaryConcern'
        }
      },
      'mdiMinoxidilFinasterideMenWomen_wereSorryDueEitherBeing',
      {
        key: 'mdiMinoxidilFinasterideMenWomen_tryingConceivePlanConceivingNear',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_tryingConceivePlanConceivingNear.yes':
                  true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_wereSorryBasedPreviousResponse'
            },
            {
              condition: { 'mdiMinoxidilFinasterideMenWomen_sex.female': true },
              key: 'mdiMinoxidilFinasterideMenWomen_requiredAcknowledgmentUnderstandFormulationContains'
            }
          ],
          els: 'mdiMinoxidilFinasterideMenWomen_primaryConcern'
        }
      },
      'mdiMinoxidilFinasterideMenWomen_wereSorryBasedPreviousResponse',
      'mdiMinoxidilFinasterideMenWomen_requiredAcknowledgmentUnderstandFormulationContains',
      'mdiMinoxidilFinasterideMenWomen_primaryConcern',
      'mdiMinoxidilFinasterideMenWomen_didFirstNoticeHairLoss',
      'mdiMinoxidilFinasterideMenWomen_whereHairLossOccurring',
      'mdiMinoxidilFinasterideMenWomen_hairLoss',
      'mdiMinoxidilFinasterideMenWomen_familyHistoryHairLoss',
      'mdiMinoxidilFinasterideMenWomen_conditions',
      {
        key: 'mdiMinoxidilFinasterideMenWomen_everDiagnosed',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_everDiagnosed.androgenetic_alopecia':
                  true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_provideDoctorMoreInsightRegarding'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_everDiagnosed.alopecia_areata':
                  true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_provideDoctorMoreInsightRegarding'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_everDiagnosed.telogen_effluvium':
                  true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_provideDoctorMoreInsightRegarding'
            }
          ],
          els: 'mdiMinoxidilFinasterideMenWomen_usingHairLossTreatmentsIncludes'
        }
      },
      'mdiMinoxidilFinasterideMenWomen_provideDoctorMoreInsightRegarding',
      'mdiMinoxidilFinasterideMenWomen_usingHairLossTreatmentsIncludes',
      {
        key: 'mdiMinoxidilFinasterideMenWomen_youuseProducts',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_youuseProducts.prp': true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_youuseProducts.minoxidil': true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_youuseProducts.retinoids_e_g_tretinoin':
                  true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_youuseProducts.finasteride':
                  true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_youuseProducts.dutasteride':
                  true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_youuseProducts.ketoconazole_shampoo':
                  true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideMenWomen_youuseProducts.microneedling':
                  true
              },
              key: 'mdiMinoxidilFinasterideMenWomen_experienceProductsTried'
            }
          ],
          els: 'mdiMinoxidilFinasterideMenWomen_scalpIrritationOpenWoundsInfection'
        }
      },
      'mdiMinoxidilFinasterideMenWomen_experienceProductsTried',
      'mdiMinoxidilFinasterideMenWomen_scalpIrritationOpenWoundsInfection',
      'mdiMinoxidilFinasterideMenWomen_redness',
      'mdiMinoxidilFinasterideMenWomen_history',
      'mdiMinoxidilFinasterideMenWomen_usingScalp',
      {
        key: 'mdiMinoxidilFinasterideMenWomen_historyLowBloodPressureDizziness',
        next: {
          switch: [
            {
              condition: { 'mdiMinoxidilFinasterideMenWomen_sex.female': true },
              key: 'mdiMinoxidilFinasterideMenWomen_experiencedDecreasedLibidoLately'
            },
            {
              condition: { 'mdiMinoxidilFinasterideMenWomen_sex.male': true },
              key: 'mdiMinoxidilFinasterideMenWomen_experienced'
            }
          ],
          els: 'mdiMinoxidilFinasterideMenWomen_fertilityConcerns'
        }
      },
      {
        key: 'mdiMinoxidilFinasterideMenWomen_experiencedDecreasedLibidoLately',
        next: {
          condition: { 'mdiMinoxidilFinasterideMenWomen_sex.male': true },
          key: 'mdiMinoxidilFinasterideMenWomen_experienced',
          els: 'mdiMinoxidilFinasterideMenWomen_fertilityConcerns'
        }
      },
      'mdiMinoxidilFinasterideMenWomen_experienced',
      {
        key: 'mdiMinoxidilFinasterideMenWomen_fertilityConcerns',
        next: {
          condition: {
            'mdiMinoxidilFinasterideMenWomen_fertilityConcerns.yes': true
          },
          key: 'mdiMinoxidilFinasterideMenWomen_provideDoctorMoreInsightRegarding2',
          els: 'mdiMinoxidilFinasterideMenWomen_historyDepressionAnxietyMoodDisorders'
        }
      },
      'mdiMinoxidilFinasterideMenWomen_provideDoctorMoreInsightRegarding2',
      {
        key: 'mdiMinoxidilFinasterideMenWomen_historyDepressionAnxietyMoodDisorders',
        next: {
          condition: {
            'mdiMinoxidilFinasterideMenWomen_historyDepressionAnxietyMoodDisorders.yes':
              true
          },
          key: 'mdiMinoxidilFinasterideMenWomen_provideDoctorFurtherInsightHistory',
          els: 'mdiMinoxidilFinasterideMenWomen_history2'
        }
      },
      'mdiMinoxidilFinasterideMenWomen_provideDoctorFurtherInsightHistory',
      {
        key: 'mdiMinoxidilFinasterideMenWomen_history2',
        next: {
          condition: { 'mdiMinoxidilFinasterideMenWomen_sex.male': true },
          key: 'mdiMinoxidilFinasterideMenWomen_ever',
          els: 'mdiMinoxidilFinasterideMenWomen_rateStressLevelDailyBasis'
        }
      },
      'mdiMinoxidilFinasterideMenWomen_ever',
      'mdiMinoxidilFinasterideMenWomen_rateStressLevelDailyBasis',
      {
        key: 'mdiMinoxidilFinasterideMenWomen_experiencedRecentMajorStressIllness',
        next: {
          condition: {
            'mdiMinoxidilFinasterideMenWomen_experiencedRecentMajorStressIllness.yes':
              true
          },
          key: 'mdiMinoxidilFinasterideMenWomen_provideDoctorMoreInsightRecent',
          els: 'mdiMinoxidilFinasterideMenWomen_uploadClearWellLitPhoto'
        }
      },
      'mdiMinoxidilFinasterideMenWomen_provideDoctorMoreInsightRecent',
      'mdiMinoxidilFinasterideMenWomen_uploadClearWellLitPhoto',
      'mdiMinoxidilFinasterideMenWomen_importantClickAttachedLinkReview',
      'mdiMinoxidilFinasterideMenWomen_firstMessageDoctor',
      'mdiMinoxidilFinasterideMenWomen_complete'
    ]
  };
